module.exports = __webpack_public_path__ + "static/media/laxmiraj-banner1.e0e35167.png";